import axios from 'axios'

class EaApi {
  static send (email, name) {
    return axios.post(`v1/ea`, { email, name })
  }
}

export default EaApi
